import { IconButton } from '@liveauctioneers/hammer-ui-core/iconButton';
import { ArrowsOutSimple } from '@liveauctioneers/hammer-ui-core/icons';
import { WebRTCPlayer } from '@liveauctioneers/hammer-ui-core/webRTCPlayer';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { useFetchStreamId, useStreamIdPolling } from '@/hooks/useStreamIdPolling';
import { useAppSelector } from '@/redux/hooks';
import { getAntMediaHostname } from '@/redux/modules/config';

const PLACEHOLDER_URL = 'https://p1.liveauctioneers.com/dist/images/auction16x9.jpg?quality=50';

type Props = {
    bigVideo: boolean;
    catalogId: number;
    showMobileConsole: boolean;
    toggleBigVideo: () => void;
};

/**
 * Video player for auction livestream
 */
const AuctionVideoStream = ({ bigVideo, catalogId, showMobileConsole, toggleBigVideo }: Props) => {
    const streamId = useStreamIdPolling(catalogId);
    const fetchStreamId = useFetchStreamId(catalogId);
    const antMediaHostname = useAppSelector(getAntMediaHostname);

    return (
        <div
            className={cn(
                'absolute -bottom-[5px] -right-[5px] z-[1000] flex h-[120px] w-[213px] items-center transition-all duration-[250ms] ease-in-out',
                showMobileConsole && 'bottom-0 right-0 h-[58px] w-[102px] border-2 border-border-black',
                bigVideo && 'h-full w-full'
            )}
        >
            <WebRTCPlayer
                fetchStreamId={fetchStreamId}
                hostname={antMediaHostname}
                placeholderUrl={PLACEHOLDER_URL}
                streamId={streamId}
            />
            <IconButton
                aria-label={bigVideo ? 'Shrink video' : 'Enlarge video'}
                className="absolute right-2xs top-2xs z-[2]"
                icon={ArrowsOutSimple}
                onClick={toggleBigVideo}
                shape="square"
                size="sm"
                style="inverse"
                variant="transparent"
            />
        </div>
    );
};

export default AuctionVideoStream;
